import { propertyPaths, PROPERTY_BASE } from './property-owner/paths';
import { PROVIDER_BASE } from './service-provider/paths';

// The role dashboards a signed-in user has content in. Used by the site header
// shortcuts and by the login redirect. (Hotels have their own account type and login.)
// - Property dashboard: anyone who has at least one listing (agents too)
// - Provider dashboard: service providers approved by an admin
export const dashboardsFor = (user) => {
  if (!user) return [];
  const links = [];
  if (user.propertyCount > 0 || user.is_property_owner === 'yes' || user.is_agent === 'yes') {
    links.push({ key: 'property', to: PROPERTY_BASE, label: 'sidebar.manage_properties' });
  }
  if (user.is_service_provider === 'yes') {
    links.push({ key: 'provider', to: PROVIDER_BASE, label: 'sidebar.manage_services' });
  }
  return links;
};

// Every signed-in user can list a property; this is where the flow starts.
export const LIST_PROPERTY_PATH = propertyPaths.add;
